import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
/**
 * ContentWrap - A responsive container component that provides consistent
 * side spacing and max-width constraints for page content.
 *
 * Features:
 * - Responsive padding that adapts to screen size
 * - Configurable maximum width
 * - Customizable padding variants
 * - Support for different HTML elements
 * - TypeScript support with strict typing
 *
 * @example
 * ```tsx
 * <ContentWrap maxWidth="4xl" padding="lg">
 *   <h1>Page Title</h1>
 *   <p>Page content goes here...</p>
 * </ContentWrap>
 * ```
 */
export const ContentWrap = ({ children, className = '', as = 'div', maxWidth = '7xl', padding = 'md', center = true, }) => {
    const Component = as;
    // Max width classes mapping
    const maxWidthClasses = {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-xl',
        '2xl': 'max-w-2xl',
        '3xl': 'max-w-3xl',
        '4xl': 'max-w-4xl',
        '5xl': 'max-w-5xl',
        '6xl': 'max-w-6xl',
        '7xl': 'max-w-7xl',
        full: 'max-w-full',
    };
    // Padding classes mapping - responsive by default
    const paddingClasses = {
        none: '',
        sm: 'px-2 sm:px-4',
        md: 'px-4 sm:px-6 lg:px-8',
        lg: 'px-6 sm:px-8 lg:px-12',
        xl: 'px-8 sm:px-12 lg:px-16',
    };
    // Combine all classes
    const combinedClasses = [
        'w-full',
        maxWidthClasses[maxWidth],
        paddingClasses[padding],
        center ? 'mx-auto' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return _jsx(Component, { className: combinedClasses, children: children });
};
//# sourceMappingURL=ContentWrap.js.map